// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1s3YP7tuEEx6rk9GIIWtoz","titleWripper":"_3G8Z41G1ggve0ZjMpkqJj8","blockImage":"_31wJfRx84aubO7pDRcVnAj","information":"_9uzJORfTbTHA0Jg8NIcJA","inputsWrapper":"_2UuqUTtl1DjaDC5PGvuLFP","columnInputs":"_2tKrHhy1GzBMYwxnHINv8_","submitBlock":"_2dIkYzJM_4bggDBwbhTt0L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LetterSubscriptionForm/LetterSubscriptionForm.scss
// module id = 1623
// module chunks = 0